import React, { useEffect, useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import { TPhasePercentagesItem } from '../../kpiTypes';
import { formatValueAsString } from '../../../../utils/helpers';
import { ChartContainer } from '../../../../shared/components/charts/ChartContainer';

export interface IOperationalPhaseChartProps {
	chartKey: number;
	phasePercentagesData: TPhasePercentagesItem[];
}

const OperationalPhaseChart: React.FC<IOperationalPhaseChartProps> = ({ chartKey, phasePercentagesData }) => {
	const formatOptions: Intl.NumberFormatOptions = { minimumFractionDigits: 0, maximumFractionDigits: 1 };

	const phaseColors: { [key: string]: string } = {
		Anchored: '#183d57',
		'At Berth': '#f0d035',
		'At Sea': '#1e503e',
		Manoeuvring: '#7cb5ec',
	};

	const data = Array.isArray(phasePercentagesData) ? phasePercentagesData : [];

	const [options, setOptions] = useState<AgChartOptions>({
		data: data,
		series: [
			{
				//data: data,
				type: 'pie',
				calloutLabelKey: 'operationalPhase',
				angleKey: 'percentOfPhase',
				calloutLabel: {
					avoidCollisions: false,
					offset: 0,
					fontSize: 10,
					formatter: ({ datum, angleKey }) => formatValueAsString(datum[angleKey], formatOptions, '', '', '%'), // Shows percentage on the chart
				},
				calloutLine: {
					colors: phasePercentagesData
						? phasePercentagesData.map((phase) => phaseColors[phase.operationalPhase] || '#000000')
						: ['#000000', '#000000', '#000000', '#000000'],
				},
				tooltip: {
					renderer: ({ datum, angleKey, calloutLabelKey = 'operationalPhase' }) => ({
						title: `${datum[calloutLabelKey]}`,
						heading: formatValueAsString(datum[angleKey], formatOptions, '', '', '%'),
						data: undefined,
					}),
				},
				fills: phasePercentagesData ? phasePercentagesData.map((phase) => phaseColors[phase.operationalPhase] || '#000000') : [],
			},
		],
		legend: {
			enabled: true,
			position: 'left',
			item: {
				label: {
					formatter: (params) => {
						const item = phasePercentagesData.find((_, index) => index === params.itemId);
						return item ? item.operationalPhase : params.itemId;
					},
				},
			},
		},
	});

	const downloadableData = data.map((item) => ({
		operationalPhase: item.operationalPhase,
		percentOfPhase: item.percentOfPhase,
	}));

	// Update chart data when props change
	useEffect(() => {
		const newData = Array.isArray(phasePercentagesData) ? phasePercentagesData : [];
		setOptions((prevOptions) => ({
			...prevOptions,
			data: newData,
		}));
	}, [phasePercentagesData]);

	return (
		<ChartContainer data={downloadableData} filename="operational_phase_chart" buttonPosition="top-right">
			<AgCharts key={chartKey} options={options} className="w-full h-full pt-1" />
		</ChartContainer>
	);
};

export default OperationalPhaseChart;
